import * as Yup from 'yup';

export const getSchema = () => {
  return Yup.object().shape({
    title: Yup.string().nullable(),
  });
};
